import UnitSystem from './UnitSystem';
import { FloChartFormatterFunction } from 'components';
import moment from 'moment';
import { Location } from './Location';

const DEFAULT_FORMAT = 'YYYY-MM-DD';

export enum ConsumptionPeriod {
  TODAY,
  LAST_24_HOURS,
  THIS_WEEK,
  LAST_28_DAYS,
  LAST_12_MONTHS,
  LAST_HOUR,
}

export interface ConsumptionMeasure {
  value: number;
  time: string;
}

interface ConsumptionMeasuresMetadata {
  unit: UnitSystem;
  short: string;
  long: string;
  timezone: string;
}


export interface ConsumptionData {
  items: ConsumptionMeasure[];
  metadata: ConsumptionMeasuresMetadata;
}

export interface FormattedConsumptionData {
  xAxis: string[];
  values: number[];
  unitSystem: string;
  formatter?: FloChartFormatterFunction;
}

type DownloadData = Array<Array<string>>;

export interface FormattedConsumptionTable {
  columns: Array<{
    id: string,
    title: string
  }>;
  data: Array<{
    [columnId: string]: string
  }>;
  download: DownloadData;
}

export enum IntervalType {
  HOURS,
  DAYS,
  WEEKS,
  MONTHS
}

export interface DateRange {
  from?: string;
  to?: string;
}

export interface ConsumptionFilter {
  locations: Array<Required<Pick<Location, 'id' | 'nickname'>>>;
  dateRange: DateRange;
}

export function getDateRange(type: IntervalType): DateRange {
  switch (type) {
    case IntervalType.HOURS:
      return {
        from: moment().startOf('day').format(DEFAULT_FORMAT),
        to: moment().add(1, 'day').startOf('day').format(DEFAULT_FORMAT),
      }
    case IntervalType.DAYS:
      return {
        from: moment().subtract(1, 'week').startOf('day').format(DEFAULT_FORMAT),
        to: moment().startOf('day').format(DEFAULT_FORMAT),
      }
    case IntervalType.WEEKS:
      return {
        from: moment().subtract(28, 'days').startOf('day').format(DEFAULT_FORMAT),
        to: moment().startOf('day').format(DEFAULT_FORMAT),
      }
    case IntervalType.MONTHS:
      return {
        from: moment().subtract(12, 'months').startOf('day').format(DEFAULT_FORMAT),
        to: moment().startOf('day').format(DEFAULT_FORMAT),
      }
  }
}
